import React from 'react';

const QuotationLabel = () => (
<svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5453 0H3.98136C2.19417 0 0.745361 1.44881 0.745361 3.236V22.652C0.745361 24.4392 2.19417 25.888 3.98136 25.888H16.9254C18.7126 25.888 20.1614 24.4392 20.1614 22.652V7.6161C20.1614 7.18698 19.9909 6.77544 19.6875 6.472L13.6894 0.473901C13.3859 0.170467 12.9744 0 12.5453 0ZM12.8804 5.663V2.427L17.7344 7.281H14.4984C13.6048 7.281 12.8804 6.5566 12.8804 5.663ZM2.36336 14.562H18.5434V16.18H7.21736V19.416H18.5434V21.034H7.21736V24.27H5.59936V21.034H2.36336V19.416H5.59936V16.18H2.36336V14.562Z" fill="#141414"/>
</svg>
);

export default QuotationLabel;
